export enum OptionButtonWidgetComponentIds {
  Repeater = '#repeater1',
  Label = '#label',
  TopContainer = '#topContainer',
  ErrorMessage = '#errorMessage1',
  OptionButtons = '#optionButtons',
}

export enum OptionButtonStates {
  Default = 'default',
  Selected = 'selected',
}

export const OptionButtonItemComponentIds = {
  MultiStateBox: '#multiStateBox1',
  SelectableContainer: '#selectableContainer1',
  SelectedText: '#text1',
  SelectedBox: '#box4',
  DefaultText: '#text2',
  DefaultBox: '#box2',
} as const;

export enum OptionButtonWidgetEvents {
  Change = 'change',
}

export enum OptionButtonWidgetMethods {
  Focus = 'focus',
}
